import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://unjcdgdcblrkpebbrzen.supabase.co"
const supabaseKey = "sb_publishable_MWIMBSMnjT7XFfp-V5ZWJg_Ig9Lk_ok"

export const supabase = createClient(supabaseUrl, supabaseKey)